export default {
    path: '/fileCheck',
    name: 'fileCheck',
    component: () =>
        import(/* webpackChunkName: "about" */ "@/pages/fileCheck/index.vue"),
    meta: {
        title: '查看文件'
    }
}
